<template lang="pug">
    div.phone.modify-phone
        el-dialog(
            :title="step === 1 ? '修改手机号' : '修改成功'"
            :visible.sync="phoneData.show"
            :close-on-click-modal="false"
            width="516px"
            center
        )
            el-form(
                :model="modifyPhoneForm"
                :rules="rules"
                ref="modifyPhoneForm"
                label-width="110px"
            )
                el-form-item(
                    prop="phone"
                    label="新手机号："
                    v-if="step === 1"
                )
                    el-input(
                        v-model="modifyPhoneForm.phone"
                        maxlength="11"
                        style="width: 320px"
                        placeholder="请输入新手机号"
                    )
                el-form-item(
                    prop="captcha"
                    label="图形验证码："
                    v-if="step === 1"
                )
                    el-input(
                        v-model="modifyPhoneForm.captcha"
                        maxlength="4"
                        style="width: 220px"
                        placeholder="请输入右侧验证码"
                    )
                    span.captcha(
                        @click="refreshCaptcha"
                    )
                        img(
                            :src="this.captchaImg"
                        )
                    i.el-icon-refresh-right(
                        @click="refreshCaptcha"
                    )
                el-form-item(
                    prop="verifyCode"
                    label="短信验证码："
                    v-if="step === 1"
                )
                    div(
                        style="display: flex"
                    )
                        el-input(
                            v-model="modifyPhoneForm.verifyCode"
                            maxlength="6"
                            style="width: 220px"
                            placeholder="请输入短信验证码"
                        )
                        el-button.send-verify-code(
                            type="text"
                            @click="getThpCode"
                            :disabled="!!countdown"
                        ) {{ countdown ? `短信已发送(${countdown}S)`:'发送短信验证码' }}
            div.success(
                v-if="step === 2"
            )
                i.el-icon-success
                span 手机号修改成功
                div.successText 您修改的新手机号为：{{ modifyPhoneForm.phone }}
            span(
                slot="footer"
            )
                el-button(
                    style="width: 110px"
                    @click="handleSubmit"
                    type="primary"
                    round
                ) {{buttonText}}
</template>

<script>
import { mapActions, mapState } from 'vuex';
import {
    loginApis,
} from '@/api';

export default {
    name: 'ModifyPhone',
    props: {
        phoneData: {
            type: Object,
            default: () => ({
                userId: 0,
                show: true,
            }),
        },
    },
    data() {
        return {
            step: 1,
            countdown: 0,
            buttonText: '提交',
            timer: '',
            captchaImg: '',
            captchaKey: '',
            modifyPhoneForm: {
                phone: '',
                captcha: '',
                verifyCode: '',
            },
            rules: {
                phone: [
                    {
                        required: true,
                        message: '请输入新手机号',
                        trigger: 'blur',
                    },
                    {
                        pattern: /^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/,
                        message: '请输入正确的手机号',
                        trigger: 'blur',
                    },
                ],
                captcha: [
                    {
                        required: true,
                        message: '请输入右侧验证码',
                        trigger: 'blur',
                    },
                    {
                        min: 4,
                        max: 4,
                        message: '图形验证码格式错误',
                        trigger: 'blur',
                    },
                ],
                verifyCode: [
                    {
                        required: true,
                        message: '请输入6位验证码',
                        trigger: 'blur',
                    },
                    {
                        pattern: /^\d{6}$/,
                        message: '短信验证码错误，请重新输入',
                        trigger: 'blur',
                    },
                ],
            },
        };
    },
    mounted() {
        this.getCaptcha();
    },
    computed: {
        ...mapState('user', [
            'userInfo',
        ]),
    },
    destroyed() {
        if (this.timer) clearInterval(this.timer);
    },
    methods: {
        ...mapActions('user', [
            'resetUserInfo',
        ]),
        handleSubmit() {
            this.$refs.modifyPhoneForm.validate(async (valid) => {
                if (!valid) return;
                if (this.step === 1) {
                    try {
                        await loginApis.modifyPhone({
                            phone: this.modifyPhoneForm.phone,
                            verifyCode: this.modifyPhoneForm.verifyCode,
                        });
                        const userInfo = {
                            ...this.userInfo,
                            phone: this.modifyPhoneForm.phone,
                        };
                        this.resetUserInfo(userInfo);
                        this.$bus.$emit('UserManageHome-refresh');
                        this.step = 2;
                        this.buttonText = '确定';
                    } catch (err) {
                        throw new Error(err);
                    }
                    return;
                }
                if (this.step === 2) {
                    this.$message({
                        message: '手机号修改成功',
                        type: 'success',
                    });
                    this.phoneData.show = false;
                }
            });
        },
        async getCaptcha() {
            const {
                data,
            } = await loginApis.getCaptcha();
            this.captchaImg = data.captcha_img;
            this.captchaKey = data.captcha_key;
        },
        refreshCaptcha() {
            this.getCaptcha();
        },
        getThpCode() {
            this.$refs.modifyPhoneForm.validateField('phone', (valid) => {
                if (valid) return;
                this.$refs.modifyPhoneForm.validateField('captcha', async (valid2) => {
                    if (valid2) return;
                    try {
                        await loginApis.getThpCode({
                            captcha: this.modifyPhoneForm.captcha,
                            captcha_key: this.captchaKey,
                            phone: this.modifyPhoneForm.phone,
                        });
                        // 倒计时
                        this.codeCountDown();
                    } catch (err) {
                        this.getCaptcha();
                        throw new Error(err);
                    }
                });
            });
        },
        codeCountDown() {
            this.countdown = 60;
            this.timer = setInterval(() => {
                if (!this.countdown) {
                    clearInterval(this.timer);
                } else {
                    this.countdown--;
                }
            }, 1000);
        },
    },
};
</script>

<style scoped lang="scss">
    .phone {
        .captcha {
            width: 90px;
            height: 40px;
            display: inline-block;
            margin-left: 10px;
            cursor: pointer;
            img {
                width: 90px;
                height: 40px;
            }
        }
        .el-icon-refresh-right {
            position: absolute;
            top: 15px;
            margin-left: 5px;
            cursor: pointer;
        }
        .send-verify-code {
            margin-left: 14px;
            padding: 0 !important;
            @include font_size(text_weak_annotation);
            @include font_color(text_color_gray3);
        }
        .tips {
            text-align: center;
            margin-bottom: 20px;
            @include font_color(text_color_gray3);
        }
        .success {
            display: flex;
            flex-direction: column;
            align-items: center;
            .el-icon-success {
                font-size: 56px;
                @include font_color(color_base_assist2);
            }
            span {
                margin: 15px 0 6px 0;
                @include font_weight(text_font_weight);
                @include font_size(text_emphasize);
            }
            .successText {
                margin-bottom: 20px;
            }
        }
    }
</style>

<style lang="scss">
    .modify-phone {
        .el-dialog .el-dialog__body {
            padding: 20px 30px 0 30px;
        }
        .el-dialog__footer {
            padding-top: 0;
        }
    }
</style>
